import {Component, inject, model, OnInit, signal} from '@angular/core';
import {InputComponent, InputOptions} from "@shared/components";
import {InputModes, InputTypes} from '@core/enums';
import {untilDestroyed} from '@ngneat/until-destroy';
import {FormControl, FormGroup, ReactiveFormsModule} from '@angular/forms';
import {Subject, takeUntil} from 'rxjs';
import {APIService} from '@core/services';

@Component({
  selector: 'ncp-default-search',
  imports: [
    InputComponent,
    ReactiveFormsModule
  ],
  templateUrl: './default-search.component.html',
  styleUrl: './default-search.component.scss',
})
export class DefaultSearchComponent implements OnInit {
  private readonly apiService = inject(APIService)

  protected inputOptions = signal<InputOptions>({});

  protected data = model<any>();

  private subscription: any;
  private destroy$ = new Subject<void>();

  protected formGroup: FormGroup = new FormGroup({
    search: new FormControl<string>(''),
  });

  get search() {
    return this.formGroup.get('search') as FormControl;
  }

  ngOnInit() {
    this.inputOptions.set(
      new InputOptions({
        id: 'inputSearch',
        name: 'search',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: this.search,
        onKeyUp: this.onKeyUp
        /*
                id: 'test_control_1',
        inputClass: 'test',
        name: 'search',
        placeholder: 'search',
        type: InputTypes.text,
        mode: InputModes.search,
        initialValue: '',
        formControl: search,
        onKeyUp: onKeyUp,
        onBlur: onBlur,
        */
      })
    );
  }

  onKeyUp = (event: KeyboardEvent, value: string) => {
    console.log('onKeyUp', value);
    this.data().api.body.description = value;
    if (this.subscription) {
      this.subscription.unsubscribe();
    }

    this.subscription = this.apiService
      .call(this.data().api)
      ?.pipe(takeUntil(this.destroy$))
      .subscribe((res) => {
        if (res) {
          console.log(res);
          this.data().allData.set(res.data);
        }
      });
  }
}
